import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/page/HsCarrot/index"),
    meta: {
      title: "화성시 화상영어",
      metaInfo: [
        {
          name: "keywords",
          content:
            "화성시 화상영어, 화성 화상영어, 화성시 원어민영어, 화성 원어민영어, 화성시 화상학습, 화성시 원어민 화상영어, 화성 원어민 화상영어, 화성시 원어민 학습, 화성 원어민 학습, 화성시 영어 학습, 화성 영어 학습, 화성시 영어 화상, 화성 영어 화상, 화성시 화상 외국어교육, 화성 화상 외국어교육, 화성시 화상영어교실, 화성 화상영어교실, 화성시 원어민 화상학습, 화성 원어민 화상학습, 화성시 평생교육, 화성 평생교육, 화성시 주니어화상영어, 화성 주니어화상영어, 화성시 사회적배려대상 영어, 화성 사회적배려대상 영어, 화성시 영어 주니어, 화성 영어 주니어, 화성시 그룹 영어, 화성 그룹 영어, 화성시 영어 그룹수업, 화성 영어 그룹수업",
        },
        {
          name: "description",
          content:
            "화상영어 무료수업 신청, 영어 티칭경력 5년 이상의 차별화된 외국 원어민 선생님과 무료수업으로 맞춤 외국어 레벨을 찾아보세요!",
        },
        { name: "viewport", content: "width=device-width" },
        { property: "og:type", content: "website" },
        { property: "og:title", content: "화성시 화상영어" },
        {
          property: "og:description",
          content:
            "화상영어 무료수업 신청, 영어 티칭경력 5년 이상의 차별화된 외국 원어민 선생님과 무료수업으로 맞춤 외국어 레벨을 찾아보세요!",
        },
        { property: "og:url", content: "https://www.hscarrot.co.kr" },
        {
          property: "og:image",
          content: "https://www.hscarrot.co.kr/img/hscarrot.1df592b3.png",
        },
      ],
    },
  },
];
const hscarrot = new VueRouter({
  mode: "history",
  routes,
});

hscarrot.afterEach((to, from) => {
  const title = to.meta.title === undefined ? "CarrotSolutions" : to.meta.title;
  Vue.nextTick(() => {
    document.title = title;
  });
});

export default hscarrot;
